import React from 'react'
import { useTable } from '../../Components/useTable';



const Reseller = () => {
const type="Reseller"
    const headCells = [
        { id: "rid", numeric: false, label: "Resller RID" },
        { id: "name", numeric: false, label: "Name" },
        { id: "email", numeric: false, label: "Email" },
        { id: "picture", numeric: false, label: "Picture" },
        { id: "country", numeric: false, label: "Country" },
        { id: "status", numeric: false, label: "Status" },
        { id: "dropdown1", numeric: false, label: "Status" },
        { id: "created", numeric: false, label: "Created at" },
        { id: "action", numeric: false, label: "Action" },
      ];
   
      const { tableUI } = useTable({
        headCells,
        type
      });
  return (

<div className='admin-body'>
      <div className="table-area">{tableUI}</div>
    </div>
    
  )
}

export default Reseller